import { render, staticRenderFns } from "./AccountPermissionsModal.vue?vue&type=template&id=1d8caa35&scoped=true"
import script from "./AccountPermissionsModal.vue?vue&type=script&lang=js"
export * from "./AccountPermissionsModal.vue?vue&type=script&lang=js"
import style0 from "./AccountPermissionsModal.vue?vue&type=style&index=0&id=1d8caa35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8caa35",
  null
  
)

export default component.exports